import "./btns.css";
export default function BtnLink({
  children,
  src,
  fullWidth = false,
  variant,
  icon,
  disabled,
  border = false,
  bg = false,
  width,
}) {
  return (
    <a
      href={src}
      type="button"
      className={`link ${variant} ${fullWidth ? "fullWidth" : ""} ${icon ? "iconArrow" : ""} ${disabled ? "disabled" : ""} ${border ? "border" : ""} ${bg ? "bg-less" : "bg-blue"} ${width}`}
    >
      {children}
    </a>
  );
}
